import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Button, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Recaptcha, { getRecaptchaToken } from "../../shared/Recaptcha";
import { forgotPassword } from "../../api/Api";
import GlowCard from '../../shared/GlowCard';
import { useColors } from '../../theme/ColorModeContext';
import AuthBrandHeader from '../../shared/AuthBrandHeader';

const ForgotPassword = () => {
    const colors = useColors();
    const [message, setMessage] = useState("");
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const email = `${data.get("email")}`;
        setProcessing(true);
        let recaptcha_token: string;
        try {
            recaptcha_token = await getRecaptchaToken();
        } catch {
            setProcessing(false);
            setMessage("Could not load reCAPTCHA. Check your connection or content blocker and try again");
            return;
        }
        const response = await forgotPassword({
            email: email,
            recaptcha_token,
        });
        setProcessing(false);
        setMessage(response.msg);
    };

    return (
        <Container sx={{ marginTop: '120px', marginBottom: '60px' }} disableGutters maxWidth="sm" className="page-enter">
            <AuthBrandHeader />
            <GlowCard gradientBorder sx={{ padding: '48px 32px' }}>
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <Typography variant="h4" sx={{
                        fontFamily: '"Orbitron", sans-serif',
                        fontWeight: 700,
                        background: colors.gradient.primary,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        marginBottom: '32px',
                    }}>
                        Forgot Password
                    </Typography>
                    <Box sx={{ width: '100%' }}>
                        <TextField margin="normal" required fullWidth id="email" label="Email" name="email" autoFocus />
                        <Recaptcha />
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={6}>
                                <Link to={"/login"} style={{ textDecoration: 'none' }}>
                                    <Button fullWidth variant="outlined">Back</Button>
                                </Link>
                            </Grid>
                            <Grid item xs={6}>
                                <Button type="submit" fullWidth variant="contained" disabled={processing}>
                                    Send
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    {message && (
                        <Typography variant="body2" sx={{
                            color: colors.accent.cyan,
                            marginTop: '16px',
                            padding: '8px 12px',
                            backgroundColor: colors.accent.cyanGlow,
                            borderRadius: '8px',
                            textAlign: 'center',
                        }}>
                            {message}
                        </Typography>
                    )}
                </Box>
            </GlowCard>
        </Container>
    );
}

export default ForgotPassword;
